(ns scittle.loom
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [loom.graph]
    [loom.alg]
    [loom.attr]
    [loom.label]
    [loom.derived]))

;; Plugin: loom
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::loom
   {:namespaces
   {'loom.graph (sci/copy-ns loom.graph (sci/create-ns 'loom.graph nil))
    'loom.alg (sci/copy-ns loom.alg (sci/create-ns 'loom.alg nil))
    'loom.attr (sci/copy-ns loom.attr (sci/create-ns 'loom.attr nil))
    'loom.label (sci/copy-ns loom.label (sci/create-ns 'loom.label nil))
    'loom.derived (sci/copy-ns loom.derived (sci/create-ns 'loom.derived nil))}}
   ))
